import { useState } from "react";
import AddInvestor from "./AddInvestor";
import VIewInvestorProdCodes from "./ViewInvestorProdCodes";
import { useNavigate } from "react-router-dom";

const AddInvestorRoute = () => {
  const [showProductCodes, setShowProductCodes] = useState(false);
  const [investorData, setInvestorData] = useState<any>(null);
  const navigate = useNavigate();

  return (
    <div className="flex justify-center">
      <div className="w-3/5 px-4 py-5 rounded-lg shadow-lg">
        {!showProductCodes && (
          <AddInvestor
            mode="add"
            onSuccess={(response: any, isBondInvestor: boolean) => {
              setInvestorData(response?.data);
              setShowProductCodes(isBondInvestor);
              navigate(`/investor/${response?.data?.id}`);
            }}
          />
        )}

        {showProductCodes && (
          <VIewInvestorProdCodes selectedInvestor={investorData} />
        )}
      </div>
    </div>
  );
};

export default AddInvestorRoute;
